/**
 * Created by portiz on 11/11/2018.
 */
import React from 'react';
import { Input } from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of the subscription in a simple select box
 */
class SelectorUserPlans extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection

            hasState: false
        };
    }

    /**
     * Call the data API
     */
    callData(){

        // This is promise
        let apiCall = ApiCalls.getUserSubscriptions();
        let arrOptions = [];

        arrOptions.push(
            <option key={""} value={""}>
                <Translate id="subscriptions.select-subscription" options={{renderInnerHtml: false}}/>
            </option>
        );



        // After the api call, fill the data
        apiCall.then((data)=>{
            // Now fill the selections
            for (let i = 0; i < data.Subscriptions.length; i++)
            {
                arrOptions.push(
                    <option key={data.Subscriptions[i].SubscriptionId} value={data.Subscriptions[i].SubscriptionId}>
                        { data.Subscriptions[i].Plan.PlanDescriptionByLang[0].Name
                        + ' (' + data.Subscriptions[i].CreatedDate + ')' }
                    </option>
                );
            }
        }).then(()=>{
            // Then, set the state
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (event) => {
        this.setState({value: event.target.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Input type="select" className="form-control" name="subscription" onChange={this.handleChange} value={this.props.value}>
                {this.state.options}
            </Input>
        )
    }
}

export default SelectorUserPlans;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-subscriptions.js